module.exports = {"330328100":"大峃镇","330328101":"百丈漈镇","330328102":"南田镇","330328103":"西坑畲族镇","330328104":"黄坦镇","330328105":"珊溪镇","330328106":"巨屿镇","330328107":"玉壶镇","330328108":"峃口镇","330328109":"周壤镇","330328110":"铜铃山镇","330328111":"二源镇","330328217":"周山畲族乡","330328225":"桂山乡","330328226":"双桂乡","330328227":"平和乡","330328228":"公阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330328.json
// module id = 974
// module chunks = 0